import { render, staticRenderFns } from "./LittleGateHeight.vue?vue&type=template&id=ec5ca882&scoped=true"
import script from "./LittleGateHeight.vue?vue&type=script&lang=ts"
export * from "./LittleGateHeight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5ca882",
  null
  
)

export default component.exports